export const clearAllNode = (attr) => {
  const candidats = document.querySelectorAll(attr);
  if (candidats.length) {
    candidats.forEach((node) => node.remove());
  }
};

export const searchValueToArray = (value) => {
  if (!value) return [];

  return value
    .split(/\s+/)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);

  return array;
};
